import { render, staticRenderFns } from "./MelDetail.vue?vue&type=template&id=02a07aa8&scoped=true"
import script from "./MelDetail.vue?vue&type=script&lang=js"
export * from "./MelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a07aa8",
  null
  
)

export default component.exports